<template>
  <div style="display: flex; flex-direction: column;">
    <header-section></header-section>
    <demo-banner></demo-banner>
    <search-section></search-section>
    <list-section v-if="listActive"></list-section>
    <error-snack-bar></error-snack-bar>
    <div style="margin-top: 200px;"></div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import HeaderSection from './components/HeaderSection.vue';
import ListSection from './components/list/ListSection.vue';
import SearchSection from './components/SearchSection.vue';
import { usePageStatus } from './store/pageStatus';
import ErrorSnackBar from './components/ErrorSnackBar.vue';
import DemoBanner from './components/DemoBanner.vue';

export default {
  name: 'BandsApp',
  components: {
    'header-section': HeaderSection,
    'demo-banner': DemoBanner,
    'search-section': SearchSection,
    'list-section':  ListSection,
    'error-snack-bar': ErrorSnackBar
  },
  beforeMount() {
    this.updateSize();
  },
  mounted() {
    window.addEventListener("resize", this.updateSize);
    document.title = 'bands';
  },
  unmounted() {
    window.removeEventListener("resize", this.updateSize);
  },
  methods: {
    ...mapActions(usePageStatus, ['updatePageSize']),
    updateSize () {
      this.updatePageSize(document.documentElement.clientWidth, document.documentElement.clientHeight)
    }
  },
  computed: {
    ...mapState(usePageStatus, ['listActive'])
  }
}
</script>

<style>
#app {
  font-family: regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--black);
}
</style>
